import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import routes from '../../../constants/routes.json';
import { Query } from 'react-apollo';
import { PORTAL_ESTABLISHMENTS_QUERY } from './graphql';
import WalletMenuItem from '../../Pages/Wallet/WalletMenuItem';


function checkCommisionTransfersPermissions(permission, userId) {
    // this checks if the user owner is gustavo (financeiro)
    if (userId === "4") {
        return true;
    }

    // const allowedPermissions = ["FINANCIAL", "ADMIN", "SUPERVISOR"];
    // if (allowedPermissions.includes(permission)) {
    //     return true;
    // }
    // return false;
}


export default function Services(props) {
    const { currentUser, portalUser } = props
    const { id: userId } = currentUser
    const operatorId = {operatorId: props.operatorId}
    const permission = portalUser ? portalUser['permission'] : false
    return (
        <Fragment>
            <ul className="navbar-nav">
                <li className="nav-item">
                    <Link className="nav-link" to={routes.ROOT}>
                        <i className="fas fa-columns text-danger mr-4" />
                        <span>Painel</span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to={routes.ORDERS}>
                        <i className="fas fa-file-invoice-dollar text-danger mr-4" />
                        <span>Vendas</span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to={routes.PAYMENTS}>
                        <i className="fas fa-credit-card text-danger mr-4" />
                        <span>Transações</span>
                    </Link>
                </li>
                {/* <li className="nav-item">
                    <Link className="nav-link" to={routes.REPORTS}>
                    <i className="ni ni-pin-3 text-danger" />
                    <span>Relatórios</span>
                    </Link>
                </li> */}
                {(()=> {
                    return checkCommisionTransfersPermissions(permission, userId) ? (
                    <div>
                        <li className="nav-item">
                            <Link className="nav-link" to={routes.COMISSIONS}>
                                <i className="fas fa-hand-holding-usd text-danger mr-4" />
                                <span>Comissões</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to={routes.TRANSFERS}>
                                <i className="fas fa-comments-dollar text-danger mr-4" />
                                <span>Repasses</span>
                            </Link>
                        </li>
                    </div>
                    ): (<div></div>)
                })()}
           
                <Query
                  query={PORTAL_ESTABLISHMENTS_QUERY}
                  variables={operatorId}
                >
                {({ loading, error, data }) => {
                    if (loading) return '';
                    if (error) {
                        console.log(error)
                        return ''
                    }
                    if (data.operator){
                      const establishments = data.operator.establishments
                      const online = establishments.filter(x => x.channel == 'ONLINE')
                      if (establishments.length == online.length)
                        return ''
                    }

                    return (
                        <Fragment>
                        <li className="nav-item">
                            <Link className="nav-link" to={routes.ITEMS}>
                                <i className="fas fa-file-alt text-danger mr-4" />
                                <span>Itens</span>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link" to={routes.TERMINALS}>
                                <i className="fas fa-calculator text-danger mr-4" />
                                <span>Terminais</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to={routes.ESTABLISHMENTS}>
                                <i className="fas fa-building text-danger mr-4" />
                                <span>Estabelecimentos</span>
                            </Link>
                        </li>
                        </Fragment>
                    )
                  }}
                </Query>
                {/* <li className="nav-item">
                    <Link className="nav-link" to={routes.USERS}>
                        <i className="fas fa-users text-danger mr-4" />
                        <span>Usuários</span>
                    </Link>
                </li> */}
                {/* <li className="nav-item">
                    <Link className="nav-link" to={routes.REGISTRATION}>
                        <i className="fas fa-file-signature text-danger mr-4" />
                        <span>Cadastro</span>
                    </Link>
                </li> */}
                <WalletMenuItem />
            </ul>
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar/Items.js